module.exports = __webpack_public_path__ + "src/img/new-bold.c59debd0.svg";